import { elegir } from '../ui/layout-variant.tsx';
import { EntrarMobile } from './Entrar.mobile.tsx';
import { EntrarDesktop } from './Entrar.desktop.tsx';

export default elegir<{ onEntro: () => void }>(EntrarMobile, EntrarDesktop);
